// @flow
import { createAction } from "redux-act";

export const fetchOffSeasonRankings = createAction("Fetch Off Season Rankings Json");
export const fetchOffSeasonRankingsSuccess = createAction("Fetch Off Season Rankings Json Success");

export const fetchOffSeasonPlayers = createAction();
export const fetchOffSeasonPlayersSuccess = createAction();